import {
  Banknote,
  Calendar,
  ChevronDown,
  FileText,
  Loader2,
  Pencil,
  Save,
  Tag,
  UserPlus,
  X,
} from 'lucide-react'

const CATEGORIES = [
  'Aluguel',
  'Material',
  'Dentistas',
  'Mercado',
  'Café',
  'Luz',
  'Agua',
  'Internet',
  'Outros',
]

export default function ExpenseModal({
  error,
  form,
  isSubmitting,
  mode,
  onChange,
  onClose,
  onSubmit,
}) {
  const isEditing = mode === 'edit'
  const HeaderIcon = isEditing ? Pencil : UserPlus

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#1A1A1A]/35 p-4 backdrop-blur-[5px]"
      role="presentation"
      onMouseDown={onClose}
    >
      <section
        className="w-full max-w-[680px] overflow-hidden rounded-xl bg-white shadow-[0_22px_55px_rgba(17,24,39,0.22)] sm:max-w-[580px]"
        role="dialog"
        aria-modal="true"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="flex min-h-[64px] items-center justify-between gap-3 border-b border-[#E5DED3] px-4 sm:min-h-[76px] sm:px-8">
          <div className="flex min-w-0 items-center gap-3 sm:gap-4">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#F3E8CE] text-[#8A6819] sm:h-10 sm:w-10">
              <HeaderIcon size={18} strokeWidth={2.4} aria-hidden="true" />
            </div>
            <h2 className="min-w-0 text-base font-semibold leading-tight tracking-normal text-[#1A1A1A] sm:text-lg sm:text-2xl">
              {isEditing ? 'Editar Saída' : 'Cadastrar Nova Saída'}
            </h2>
          </div>

          <button
            className="flex h-9 w-9 items-center justify-center rounded-lg text-[#1A1A1A] transition hover:bg-[#FBF8F4] sm:h-10 sm:w-10"
            type="button"
            onClick={onClose}
            aria-label="Fechar"
          >
            <X size={16} strokeWidth={2.1} />
          </button>
        </div>

        <form onSubmit={onSubmit}>
          <div className="grid gap-4 px-4 py-5 sm:gap-5 sm:px-8 sm:py-6">
            {error ? (
              <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2.5 text-sm font-medium text-red-700">
                {error}
              </div>
            ) : null}

            <ModalField icon={Tag} label="Categoria">
              <select
                className="modal-input appearance-none"
                required
                value={form.category}
                onChange={(event) => onChange('category', event.target.value)}
              >
                <option value="">Selecione a categoria</option>
                {CATEGORIES.map((category) => (
                  <option value={category} key={category}>
                    {category}
                  </option>
                ))}
              </select>
              <ChevronDown
                className="pointer-events-none absolute right-4 top-[38px] text-[#7A7269]"
                size={18}
                strokeWidth={2.3}
                aria-hidden="true"
              />
            </ModalField>

            <ModalField icon={FileText} label="Descrição">
              <input
                className="modal-input"
                minLength="2"
                placeholder="Descrição da despesa"
                required
                value={form.description}
                onChange={(event) => onChange('description', event.target.value)}
              />
            </ModalField>

            <div className="grid gap-5 md:grid-cols-2">
              <ModalField icon={Banknote} label="Valor (R$)">
                <input
                  className="modal-input"
                  min="0"
                  placeholder="0,00"
                  required
                  step="0.01"
                  type="number"
                  value={form.value}
                  onChange={(event) => onChange('value', event.target.value)}
                />
              </ModalField>

              <ModalField icon={Calendar} label="Data">
                <input
                  className="modal-input w-full"
                  required
                  type="date"
                  value={form.date}
                  onChange={(event) => onChange('date', event.target.value)}
                />
              </ModalField>
            </div>
          </div>

          <div className="flex min-h-[76px] flex-col-reverse items-stretch justify-end gap-3 border-t border-[#E5DED3] bg-[#FBFAF8] px-4 py-4 sm:flex-row sm:items-center sm:px-8 sm:py-0">
            <button
              className="h-10 px-4 text-sm font-semibold tracking-[0.04em] text-[#1A1A1A]"
              type="button"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button
              className="flex h-10 items-center justify-center gap-2 rounded-full bg-[#1A1A1A] px-5 text-sm font-bold tracking-[0.02em] text-white shadow-sm transition hover:bg-[#2C2A28] disabled:cursor-not-allowed disabled:opacity-70"
              disabled={isSubmitting}
              type="submit"
            >
              {isSubmitting ? <Loader2 className="animate-spin" size={16} /> : <Save size={16} />}
              {isEditing ? 'Salvar Alterações' : 'Salvar Saída'}
            </button>
          </div>
        </form>
      </section>
    </div>
  )
}

function ModalField({ children, icon: Icon, label }) {
  return (
    <label className="modal-field relative grid gap-2">
      <span className="text-sm font-semibold uppercase tracking-[0.14em] text-[#1A1A1A]">
        {label}
      </span>
      <Icon
        className="pointer-events-none absolute left-4 top-[38px] text-[#7A7269]"
        size={18}
        strokeWidth={2.2}
        aria-hidden="true"
      />
      {children}
    </label>
  )
}
